
export const transliterateString = (text: string) => {
    return import(/* webpackChunkName: "transliteration" */ 'transliteration').then((transliteration) => {
        const transliteratedText = transliteration.transliterate(text);
        return transliteratedText;
    });
}
